import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, type GetIssueResponseDto } from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type UseStartActionParams = {
  issueCode: string;
};
type UseStartActionMutationParams = {
  actionId: string;
};

export function useStartAction({ issueCode }: UseStartActionParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    UseStartActionMutationParams
  >({
    mutationKey: ['actions'],
    mutationFn: ({ actionId: id }) =>
      api.issuesApi.startAction(issueCode, id).then((r) => r.data),
    onSuccess: async (issue) => {
      queryClient.setQueriesData<GetIssueResponseDto>(
        { queryKey: ['issues', issueCode], exact: true },
        () => ({ ...issue }),
      );
      // TODO: Check if we can use `setQueriesData` instead
      await queryClient.invalidateQueries({
        queryKey: ['issues', issueCode, 'timeline'],
      });
    },
  });
}
